import React from 'react';

import { IPageFields } from '../../../types/contentful';

import { AsFeaturedOn } from '../AsFeaturedOn';
import { AssetWith5050Text } from '../AssetWith5050Text';
import { BadgeList } from '../BadgeList';
import { BodyCopy } from '../BodyCopy';
import { CaliforniaResidentsTable } from '../Tables/CaliforniaResidentsTable/CaliforniaResidentsTable';
import { CareersBlock } from '../CareersBlock';
import { CollapsiblePlansList } from '../CollapsiblePlansList';
import { DataRequest } from '../DataRequest';
import { HorizontalRule } from '../HorizontalRule';
import { ImageWith5050Text } from '../ImageWith5050Text';
import { ImageWith7030Text } from '../ImageWith7030Text';
import { InfoBlock } from '../InfoBlock';
import { LegalPageSection } from '../LegalPageSection';
import { MaxInvestDisclosureTable } from '../Tables/MaxInvestDisclosureTable';
import { Milestone } from '../Milestone';
import { PlansList } from '../PlansList';
import { OptionSelect } from '../OptionSelect';
import { PlansTable } from '../PlansTable';
import { PressList } from '../PressList';
import { QuickStartGuide } from '../QuickStartGuide';
import { SectionWithCollapsibles } from '../SectionWithCollapsibles';
import { SectionWithPagePointers } from '../SectionWithPagePointers';
import { SocialProof } from '../SocialProof';
import { SplitModule } from '../SplitModule';
import { Storytelling } from '../Storytelling';
import { Tables } from '../Tables';
import { TestimonialSliderBlock } from '../TestimonialSliderBlock';
import { TileGrid } from '../TileGrid';
import { VariationContainer } from '../VariationContainer';
import { VideoBlock } from '../VideoBlock';
import { VideoBlockFullWidth } from '../VideoBlockFullWidth';
import { VideoWith5050Text } from '../VideoWith5050Text';

export function PageBlocks({ pageBlocks }: IPageFields) {
  return (
    <>
      {pageBlocks?.map(({ sys, fields }: any) => (
        <section key={sys?.id} data-cfid={sys?.id} data-testid="page-block">
          {(() => {
            switch (sys?.contentType?.sys?.id) {
              case 'asFeaturedOn':
                return <AsFeaturedOn />;

              case 'assetWith5050Text':
                return <AssetWith5050Text {...fields} sysId={sys?.id} />;

              case 'badgeList':
                return <BadgeList {...fields} sysId={sys?.id} />;

              case 'bodyCopy':
                return <BodyCopy {...fields} />;

              case 'californiaResidentTable':
                return <CaliforniaResidentsTable />;

              case 'careersBlock':
                return <CareersBlock {...fields} />;

              case 'dataRequestForm':
                return <DataRequest {...fields} />;

              case 'horizontalRule':
                return <HorizontalRule {...fields} />;

              case 'imageWith5050Text':
                return <ImageWith5050Text {...fields} sysId={sys?.id} />;

              case 'imageWith7030Text':
                return <ImageWith7030Text {...fields} />;

              case 'infoBlock':
                return <InfoBlock {...fields} />;

              case 'legalPageSection':
                return <LegalPageSection {...fields} />;

              case 'maxInvestDisclosureTable':
                return <MaxInvestDisclosureTable />;

              case 'milestone':
                return <Milestone {...fields} sysId={sys?.id} />;

              case 'optionSelect':
                return <OptionSelect {...fields} sysId={sys?.id} />;

              case 'plansList':
                return <PlansList {...fields} sysId={sys?.id} />;

              case 'plansList20':
                return <CollapsiblePlansList {...fields} sysId={sys?.id} />;

              case 'plansTable':
                return <PlansTable {...fields} />;

              case 'pressList':
                return <PressList {...fields} />;

              case 'quickStartGuide':
                return <QuickStartGuide {...fields} />;

              case 'sectionWithCollapsibles':
                return <SectionWithCollapsibles {...fields} />;

              case 'sectionWithPagePointers':
                return <SectionWithPagePointers {...fields} />;

              case 'socialProof':
                return <SocialProof {...fields} />;

              case 'splitModule':
                return <SplitModule {...fields} />;

              case 'storytelling':
                return <Storytelling {...fields} sysId={sys?.id} />;

              case 'table':
                return <Tables {...fields} />;

              case 'testimonialSlider':
                return <TestimonialSliderBlock {...fields} />;

              case 'tileGrid':
                return <TileGrid {...fields} />;

              case 'variationContainer':
                return <VariationContainer {...fields} sysId={sys?.id} />;

              case 'videoBlock':
                return <VideoBlock {...fields} />;

              case 'videoBlockFullwidth':
                return <VideoBlockFullWidth {...fields} sysId={sys?.id} />;

              case 'videoWith5050Text':
                return <VideoWith5050Text {...fields} />;

              default:
                return null;
            }
          })()}
        </section>
      ))}
    </>
  );
}
